/**
 * B418 - "is a sign-in saved on this device?", answered without waiting for the config.
 *
 * `lib/supabase.ts` saves the session in localStorage under `sb-<project ref>-auth-token`
 * (`deriveStorageKey`; with no ref found the library's own default applies, which has the same
 * shape: `sb-<first host label>-auth-token`). The config read that names the project is the slow
 * part of the boot, so this answers from the key SHAPE alone: any key that starts `sb-` and
 * carries `-auth-token`.
 *
 * The match is a prefix on purpose. It also catches `sb-<ref>-auth-token-code-verifier`, which
 * the PKCE flow writes when a sign-in starts and removes when the code is exchanged, so a visitor
 * returning from Google or Apple (no session saved YET) counts as "may be signed in" and keeps
 * the page's own loading UI rather than a blank.
 *
 * The answer errs toward true. A storage that cannot be read (private mode, a blocked or absent
 * localStorage) counts as saved: the caller hides UI only from a visitor it is SURE has no
 * session, never from someone who may be signed in.
 */
const SAVED_SESSION_KEY = /^sb-.+-auth-token/;

export function hasStoredSession(): boolean {
  try {
    const storage = window.localStorage;
    for (let i = 0; i < storage.length; i++) {
      const key = storage.key(i);
      if (key !== null && SAVED_SESSION_KEY.test(key)) return true;
    }
    return false;
  } catch {
    return true;
  }
}
